export const defaultL10nStrings = {
	advancedHierarchy: 'Advanced Hierarchy',
	apply: 'Apply',
	cancel: 'Cancel',
	saveThisHierarchy: 'Save this hierarchy',
	renderSelectionCount: (numberOfSelection: number, totalNumber: number) =>
		` (${numberOfSelection} of ${totalNumber})`,
};
